<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="shabuOrderProcess.show"
            @hidden="closeModalConditionShabu()" 
            hide-footer
        >
        <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                <h3 class="mb-0">เงื่อนไขการใช้ E-Voucher</h3>
                </div>
            </div>
            </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <h4>ขั้นตอนการซื้อ E-Voucher</h4>
            <div v-for="(item , index) in processShabu.process" :key="'P'+index" class="pl-3">
                <h5 v-html="item"></h5> 
            </div>
            <div class="mt-4 w-100 text-center">
                <b-button type="submit" variant="success" @click="closeModalConditionShabu()">ยอมรับ</b-button>
            </div>
        </card>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalOrderProcessShabu" ,
    props: {
        shabuOrderProcess: Object,
    },
    methods: {
        closeModalConditionShabu(){
            this.shabuOrderProcess.show = false
        },
    },
    computed: {
        processShabu() {
            return {
                process:[
                    '1. ลูกค้าสั่งซื้อ E-Voucher ที่หน้าร้านแฟรนไชส์ SHIPPOP SHOP',
                    '2. SHIPPOP SHOP กรอกข้อมูลในแบบฟอร์ม *กรอกอีเมล์ของสาขาในกูเกิลฟอร์ม หลังจากนั้นรหัสผ่านจะส่งผ่านทางอีเมล์อัตโนมัติ <span class="text-red">(หากกรอกแบบฟอร์มคำสั่งซื้อแล้ว จะไม่สามารถยกเลิกรายการได้)</span>',
                    '3. SHIPPOP SHOP แจ้งรหัสให้กับลูกค้า',
                    '4. ลูกค้าแอด Line@ : @Shabubootueng และส่งรหัสเพื่อขอรับ E-Voucher',
                    '5. ลูกค้าสามารถนำ E-Voucher ไปใช้ที่หน้าสาขาชาบู บู๊ตึ๊งทุกสาขาทั่วประเทศ',
                    '6. เงื่อนไขเป็นไปตามที่บริษัทฯ กำหนด',
                ],
            }
        }
    }
}
</script>